// Preview Module - Main orchestration with new tab high-res view
// UPDATED: Simplified warning logic - removed red overlay complexity
// UPDATED: Added Google Sheets logging integration
// UPDATED: Added product links below preview title

// Generate preview function - main coordination logic
async function generatePreview() {
    try {
        console.log('🎨 Resetting preview state completely...');
        currentPreview = null;
        patternImage = null;
        imageLoaded = false;
        
        // Get DOM elements once at the top
        const previewSection = document.getElementById('previewSection');
        const loadingOverlay = document.getElementById('loadingOverlay');
        const previewTitle = document.getElementById('previewTitle');
        
        if (previewSection) {
            previewSection.style.display = 'none';
        }
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const patternId = getSelectedPattern();
        const widthFeet = parseInt(document.getElementById('widthFeet').value) || 0;
        const widthInches = parseFloat(document.getElementById('widthInches').value) || 0;
        const heightFeet = parseInt(document.getElementById('heightFeet').value) || 0;
        const heightInches = parseFloat(document.getElementById('heightInches').value) || 0;
        
        console.log('🎯 Generate preview called with:', { patternId, widthFeet, widthInches, heightFeet, heightInches });
        
        // Validation
        if (!patternId) {
            alert('Please select a wallpaper pattern');
            return;
        }
        
        if (widthFeet === 0 && widthInches === 0) {
            alert('Please enter wall width');
            return;
        }
        
        if (heightFeet === 0 && heightInches === 0) {
            alert('Please enter wall height');
            return;
        }
        
        const pattern = patterns[patternId];
        if (!pattern) {
            alert('Pattern not found: ' + patternId);
            return;
        }
        
        const wallWidth = (widthFeet * 12) + widthInches;
        const wallHeight = (heightFeet * 12) + heightInches;
        
        console.log('🔢 Calculating requirements for:', { wallWidth, wallHeight });
        const calculations = calculatePanelRequirements(pattern, wallWidth, wallHeight);
        
        // UPDATED: Simplified special case checking
        let showWarning = false;
        let warningMessage = '';
        
        if (pattern.saleType === 'panel') {
            const maxAvailableLength = Math.max(...pattern.availableLengths);
            const totalHeightNeeded = wallHeight + pattern.minOverage;
            
            if (!pattern.hasRepeatHeight && calculations.panelLength === maxAvailableLength && totalHeightNeeded > (maxAvailableLength * 12)) {
                // Non-repeating pattern that doesn't cover the full wall height
                showWarning = true;
                warningMessage = CONFIG.ui.text.disclaimers.noRepeatHeight;
            } else if (totalHeightNeeded > (CONFIG.calculator.limits.maxPanelHeight * 12)) {
                // Wall exceeds the general height limit
                showWarning = true;
                warningMessage = CONFIG.ui.text.disclaimers.panelLimit;
            }
        }
        
        const formattedWidth = widthInches > 0 ? `${widthFeet}'${widthInches}"` : `${widthFeet}'`;
        const formattedHeight = heightInches > 0 ? `${heightFeet}'${heightInches}"` : `${heightFeet}'`;
        
        // Set up currentPreview object for use by other modules
        currentPreview = {
            pattern,
            wallWidth,
            wallHeight,
            calculations,
            wallWidthFeet: widthFeet,
            wallWidthInches: widthInches,
            wallHeightFeet: heightFeet,
            wallHeightInches: heightInches,
            formattedWidth: formattedWidth,
            formattedHeight: formattedHeight
        };
        
        if (previewTitle) {
            previewTitle.textContent = `${pattern.name}: ${pattern.sku || 'N/A'}: ${formattedWidth}w x ${formattedHeight}h Wall`;
        }
        
        // Product links under the preview title — removed per request.
        // (Function still exists below if you ever want to re-enable this;
        // just uncomment the line: addProductLinksToPreview(pattern);)
        
        if (loadingOverlay) {
            loadingOverlay.style.display = 'flex';
        }
        
        if (previewSection) {
            previewSection.style.display = 'block';
            previewSection.scrollIntoView({ behavior: 'smooth' });
        }
        
        console.log('🖼️ Preloading image:', pattern.imageUrl);
        await preloadPatternImage(pattern);
        
        // Update the preview info section
        updatePreviewInfo();

        // NEW: Let the price module (wp-calc-product-init.js) react to the latest
        // calculation, if it registered itself. Kept as an optional hook so this
        // file doesn't need to know anything about pricing.
        if (typeof window.wpCalcOnPreviewUpdate === 'function') {
            window.wpCalcOnPreviewUpdate(currentPreview);
        }
        
        // Draw the canvas preview (function now in canvas-drawing.js)
        drawPreview();
        
        // UPDATED: Simplified warning display with explicit red styling
        const warningElement = document.getElementById('panelLimitWarning');
        if (warningElement) {
            if (showWarning) {
                warningElement.innerHTML = `<p><em>${warningMessage}</em></p>`;
                warningElement.style.display = 'block';
                warningElement.style.color = '#dc3545';
                warningElement.style.backgroundColor = '#f8d7da';
                warningElement.style.border = '1px solid #f5c6cb';
                warningElement.style.borderRadius = '8px';
                warningElement.style.padding = '15px';
                warningElement.style.margin = '15px 0';
                warningElement.style.fontWeight = '600';
            } else {
                warningElement.style.display = 'none';
            }
        }
        
        if (loadingOverlay) {
            loadingOverlay.style.display = 'none';
        }
        
        // Add click handler for canvas high-res view in new tab
        const canvas = document.getElementById('previewCanvas');
        canvas.style.cursor = 'zoom-in';
        canvas.onclick = openHighResInNewTab;
        canvas.title = 'Click to open high-resolution view in new tab';
        
        // LOGGING: Dispatch logging event for preview generation
        if (typeof window.dispatchPreviewGenerated === 'function') {
            setTimeout(() => {
                window.dispatchPreviewGenerated({
                    patternName: pattern.name,
                    patternSku: pattern.sku,
                    wallDimensions: `${formattedWidth} x ${formattedHeight}`,
                    calculationsData: calculations,
                    timestamp: new Date().toISOString()
                });
            }, 200); // Small delay to ensure preview is fully rendered
        }
        
        console.log('✅ Preview generation complete with logging enabled');
        
    } catch (error) {
        console.error('❌ Error in generatePreview:', error);
        const loadingOverlay = document.getElementById('loadingOverlay');
        if (loadingOverlay) {
            loadingOverlay.style.display = 'none';
        }
        alert('An error occurred: ' + error.message);
    }
}

// NEW: Add product links below the preview title
function addProductLinksToPreview(pattern) {
    // Remove any existing product links container
    const existingLinks = document.getElementById('productLinksContainer');
    if (existingLinks) {
        existingLinks.remove();
    }
    
    // Create container for product links
    const linksContainer = document.createElement('div');
    linksContainer.id = 'productLinksContainer';
    linksContainer.style.cssText = `
        text-align: center;
        margin: 15px 0 20px 0;
        line-height: 1.6;
    `;
    
    // Helper function to create a styled link
    function createProductLink(url, text) {
        const link = document.createElement('a');
        link.href = /^https?:\/\//i.test(url.trim()) ? url.trim() : 'https://' + url.trim();
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = text;
        link.style.cssText = `
            color: #333333;
            text-decoration: none;
            font-family: var(--font-heading-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
            font-weight: var(--font-heading-weight, 600);
            font-style: var(--font-heading-style, normal);
            font-size: calc(1rem * var(--font-heading-scale, 1));
            display: block;
            margin: 5px 0;
            transition: color 0.3s ease;
        `;
        
        // Add hover effect
        link.addEventListener('mouseenter', function() {
            this.style.color = '#666666';
        });
        
        link.addEventListener('mouseleave', function() {
            this.style.color = '#333333';
        });
        
        return link;
    }
    
    // Add links only if URLs exist and are not empty
    if (pattern.product_tearsheet_url && pattern.product_tearsheet_url.trim()) {
        const tearsheetLink = createProductLink(pattern.product_tearsheet_url, 'Product Tearsheet >');
        linksContainer.appendChild(tearsheetLink);
    }
    
    if (pattern.product_page_url && pattern.product_page_url.trim()) {
        const pageLink = createProductLink(pattern.product_page_url, 'Product Page >');
        linksContainer.appendChild(pageLink);
    }
    
    if (pattern.product_360_url && pattern.product_360_url.trim()) {
        const view360Link = createProductLink(pattern.product_360_url, '360 View >');
        linksContainer.appendChild(view360Link);
    }
    
    // Only add the container if there are links to show
    if (linksContainer.children.length > 0) {
        // Find the title container and add links after it
        const titleContainer = document.querySelector('.title-container');
        if (titleContainer) {
            titleContainer.appendChild(linksContainer);
            console.log('✅ Product links added to preview:', linksContainer.children.length, 'links');
        }
    }
}

// Update preview info display - handles the order quantities section
function updatePreviewInfo() {
    const { calculations } = currentPreview;

    const orderQuantity = document.getElementById('orderQuantity');
    const orderQuantityWithOverage = document.getElementById('orderQuantityWithOverage');

    // Hide yardage breakdown lines — not shown in new selling format
    ['yardagePerPanel', 'totalYardage', 'yardagePerPanelOverage', 'totalYardageOverage'].forEach(id => {
        const el = document.getElementById(id);
        if (el?.parentElement) el.parentElement.style.display = 'none';
    });

    if (calculations.saleType === 'yard') {
        const rollsNeeded = calculations.rollsNeeded;
        const overageRolls = Math.ceil(rollsNeeded * 1.2);
        if (orderQuantity) orderQuantity.textContent = `[x${rollsNeeded}] 11-Yard Rolls`;
        if (orderQuantityWithOverage) orderQuantityWithOverage.textContent = `[x${overageRolls}] 11-Yard Rolls`;
    } else {
        const panelLength = calculations.panelLength;
        const displayCount = calculations.isPanelRoll ? calculations.rollsNeeded : calculations.panelsNeeded;
        const unit = calculations.isPanelRoll ? 'Rolls' : 'Panels';
        const rollNote = calculations.isPanelRoll ? ' (2 panels per roll)' : '';
        const overageCount = Math.ceil(displayCount * 1.2);
        if (orderQuantity) orderQuantity.textContent = `[x${displayCount}] ${panelLength}' ${unit}${rollNote}`;
        if (orderQuantityWithOverage) orderQuantityWithOverage.textContent = `[x${overageCount}] ${panelLength}' ${unit}${rollNote}`;
    }
}

// NEW: Open high-resolution preview in new tab using existing PDF generation code
async function openHighResInNewTab() {
    if (!currentPreview) {
        console.error('No current preview data available for high-res rendering');
        alert('Please generate a preview first');
        return;
    }
    
    try {
        console.log('🔍 Generating high-resolution preview for new tab...');
        
        // Show loading cursor
        const canvas = document.getElementById('previewCanvas');
        const originalCursor = canvas.style.cursor;
        canvas.style.cursor = 'wait';
        canvas.title = 'Generating high-resolution view...';
        
        // Generate high-resolution canvas using existing PDF generation code
        // Ultra high resolution: 4K+ for maximum sharpness and detail
        const targetWidth = 4800;  // 600 DPI equivalent for 8" width - much sharper
        const targetHeight = 3600; // 600 DPI equivalent for 6" height - much sharper
        
        console.log('📐 Generating canvas at:', targetWidth, 'x', targetHeight);
        
        // Reuse the existing generateHighResCanvas function from PDF generation
        const canvasDataUrl = await generateHighResCanvasForViewing(targetWidth, targetHeight);
        
        if (!canvasDataUrl) {
            throw new Error('Failed to generate high-resolution canvas');
        }
        
        // Create the content for the new tab
        const { pattern, formattedWidth, formattedHeight } = currentPreview;
        const title = `${pattern.name} - ${pattern.sku} - ${formattedWidth}w x ${formattedHeight}h`;
        
        // Create product links HTML for the new tab
        let productLinksHTML = '';
        const normalizeUrl = url => /^https?:\/\//i.test(url.trim()) ? url.trim() : 'https://' + url.trim();
        if (pattern.product_tearsheet_url && pattern.product_tearsheet_url.trim()) {
            productLinksHTML += `<a href="${normalizeUrl(pattern.product_tearsheet_url)}" target="_blank" rel="noopener noreferrer">Product Tearsheet ></a><br>`;
        }
        if (pattern.product_page_url && pattern.product_page_url.trim()) {
            productLinksHTML += `<a href="${normalizeUrl(pattern.product_page_url)}" target="_blank" rel="noopener noreferrer">Product Page ></a><br>`;
        }
        if (pattern.product_360_url && pattern.product_360_url.trim()) {
            productLinksHTML += `<a href="${normalizeUrl(pattern.product_360_url)}" target="_blank" rel="noopener noreferrer">360 View ></a><br>`;
        }
        
        const htmlContent = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${title}</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            background: #1a1a1a;
            color: #ffffff;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            padding: 20px;
            overflow-x: auto;
        }
        
        .header {
            text-align: center;
            margin-bottom: 30px;
            max-width: 90vw;
        }
        
        .header h1 {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 10px;
            line-height: 1.3;
            word-break: break-word;
        }
        
        .header p {
            font-size: 16px;
            opacity: 0.8;
            margin-bottom: 15px;
        }
        
        .product-links {
            margin-bottom: 15px;
            line-height: 1.6;
        }
        
        .product-links a {
            color: #ffffff;
            text-decoration: none;
            font-weight: 600;
            display: block;
            margin: 5px 0;
            transition: color 0.3s ease;
        }
        
        .product-links a:hover {
            color: #cccccc;
        }
        
        .image-container {
            max-width: 95vw;
            max-height: 80vh;
            overflow: auto;
            border: 2px solid #333;
            border-radius: 8px;
            background: white;
            padding: 10px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.5);
        }
        
        .preview-image {
            display: block;
            max-width: 100%;
            height: auto;
            cursor: zoom-in;
        }
        
        .preview-image.zoomed {
            cursor: zoom-out;
            max-width: none;
            width: auto;
            height: auto;
        }
        
        .footer {
            margin-top: 30px;
            text-align: center;
            opacity: 0.6;
            font-size: 14px;
        }
        
        @media (max-width: 768px) {
            .header h1 {
                font-size: 20px;
            }
            
            .btn {
                width: 200px;
                text-align: center;
            }
        }
    </style>
</head>
<body>
    <div class="header">
        <h1>${pattern.name}</h1>
        <p>${pattern.sku || 'N/A'} • ${formattedWidth}w x ${formattedHeight}h Wall</p>
        ${productLinksHTML ? `<div class="product-links">${productLinksHTML}</div>` : ''}
    </div>
    
    <div class="image-container">
        <img id="previewImage" class="preview-image" src="${canvasDataUrl}" alt="High-resolution wallpaper preview">
    </div>
    
    <div class="footer">
        <p>Generated by ${CONFIG.business.name} Wallpaper Calculator</p>
        <p>Right-click image to save • Click image to zoom • Z = zoom, D = download, Escape = close</p>
    </div>
    
    <script>
        let isZoomed = false;
        
        function toggleZoom() {
            const img = document.getElementById('previewImage');
            const container = img.parentElement;
            
            if (isZoomed) {
                // Zoom out - restore to fit container
                img.classList.remove('zoomed');
                container.style.overflow = 'auto';
                isZoomed = false;
            } else {
                // Zoom in - center on current visible area
                
                // Get current scroll position relative to container
                const containerRect = container.getBoundingClientRect();
                const currentScrollLeft = container.scrollLeft;
                const currentScrollTop = container.scrollTop;
                
                // Calculate the center point of the currently visible area
                const visibleCenterX = currentScrollLeft + (container.clientWidth / 2);
                const visibleCenterY = currentScrollTop + (container.clientHeight / 2);
                
                // Get current image dimensions (before zoom)
                const currentImgWidth = img.offsetWidth;
                const currentImgHeight = img.offsetHeight;
                
                // Calculate the relative position as percentage of current image
                const centerXPercent = visibleCenterX / currentImgWidth;
                const centerYPercent = visibleCenterY / currentImgHeight;
                
                // Apply zoom
                img.classList.add('zoomed');
                container.style.overflow = 'scroll';
                
                // Wait for the image to resize, then adjust scroll position
                setTimeout(() => {
                    // Get new image dimensions (after zoom)
                    const newImgWidth = img.offsetWidth;
                    const newImgHeight = img.offsetHeight;
                    
                    // Calculate where the center point is now located
                    const newCenterX = centerXPercent * newImgWidth;
                    const newCenterY = centerYPercent * newImgHeight;
                    
                    // Calculate new scroll position to keep the center point visible
                    const newScrollLeft = newCenterX - (container.clientWidth / 2);
                    const newScrollTop = newCenterY - (container.clientHeight / 2);
                    
                    // Apply the scroll position (browser will handle bounds automatically)
                    container.scrollLeft = Math.max(0, newScrollLeft);
                    container.scrollTop = Math.max(0, newScrollTop);
                    
                    console.log('🔍 Zoom centered on:', {
                        originalCenter: { x: visibleCenterX, y: visibleCenterY },
                        percentages: { x: centerXPercent, y: centerYPercent },
                        newCenter: { x: newCenterX, y: newCenterY },
                        newScroll: { left: newScrollLeft, top: newScrollTop }
                    });
                }, 50); // Small delay to ensure CSS changes are applied
                
                isZoomed = true;
            }
        }
        
        function downloadImage() {
            const link = document.createElement('a');
            link.download = '${pattern.sku || 'wallpaper'}-preview-${Date.now()}.png';
            link.href = '${canvasDataUrl}';
            link.click();
        }
        
        // Click image to zoom
        document.getElementById('previewImage').onclick = toggleZoom;
        
        // Keyboard shortcuts
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                window.close();
            } else if (e.key === 'z' || e.key === 'Z') {
                toggleZoom();
            } else if (e.key === 'd' || e.key === 'D') {
                downloadImage();
            }
        });
        
        console.log('High-resolution wallpaper preview loaded');
        console.log('Keyboard shortcuts: Z = zoom, D = download, Escape = close');
    </script>
</body>
</html>`;
        
        // Open in new tab
        const newTab = window.open('', '_blank');
        if (!newTab) {
            // Popup blocked - fallback to download
            console.warn('Popup blocked, offering download instead');
            const link = document.createElement('a');
            link.download = `${pattern.sku || 'wallpaper'}-preview-${Date.now()}.png`;
            link.href = canvasDataUrl;
            link.click();
            
            alert('Popup blocked. High-resolution image has been downloaded instead.');
        } else {
            newTab.document.write(htmlContent);
            newTab.document.close();
            console.log('✅ High-resolution preview opened in new tab');
        }
        
        // Restore canvas cursor and title
        canvas.style.cursor = originalCursor;
        canvas.title = 'Click to open high-resolution view in new tab';
        
    } catch (error) {
        console.error('❌ Error generating high-res preview:', error);
        
        // Restore canvas cursor
        const canvas = document.getElementById('previewCanvas');
        canvas.style.cursor = 'zoom-in';
        canvas.title = 'Click to open high-resolution view in new tab';
        
        alert('Error generating high-resolution preview: ' + error.message);
    }
}

// Generate high-resolution canvas specifically for viewing (adapted from PDF generation)
async function generateHighResCanvasForViewing(targetWidth, targetHeight) {
    return new Promise((resolve) => {
        try {
            // Create high-resolution canvas
            const hiResCanvas = document.createElement('canvas');
            hiResCanvas.width = targetWidth;
            hiResCanvas.height = targetHeight;
            const hiResCtx = hiResCanvas.getContext('2d');
            
            // Enable high-quality rendering
            hiResCtx.imageSmoothingEnabled = true;
            hiResCtx.imageSmoothingQuality = 'high';
            
            // Calculate scale factor
            const originalCanvas = document.getElementById('previewCanvas');
            const scaleX = targetWidth / originalCanvas.width;
            const scaleY = targetHeight / originalCanvas.height;
            
            // Use the smaller scale to maintain aspect ratio
            const scale = Math.min(scaleX, scaleY);
            
            // Calculate centered position
            const scaledWidth = originalCanvas.width * scale;
            const scaledHeight = originalCanvas.height * scale;
            const offsetX = (targetWidth - scaledWidth) / 2;
            const offsetY = (targetHeight - scaledHeight) / 2;
            
            // Fill background
            hiResCtx.fillStyle = '#ffffff';
            hiResCtx.fillRect(0, 0, targetWidth, targetHeight);
            
            // Scale and render
            hiResCtx.save();
            hiResCtx.translate(offsetX, offsetY);
            hiResCtx.scale(scale, scale);
            
            // Render the preview using existing high-quality rendering from PDF module
            renderHighQualityPreviewForViewing(hiResCtx, originalCanvas.width, originalCanvas.height);
            
            hiResCtx.restore();
            
            // Convert to data URL with high quality
            const dataUrl = hiResCanvas.toDataURL('image/png', 1.0);
            resolve(dataUrl);
            
        } catch (error) {
            console.error('Error generating high-res canvas for viewing:', error);
            resolve(null);
        }
    });
}

// Render high-quality preview for viewing (reuses PDF rendering logic)
function renderHighQualityPreviewForViewing(ctx, canvasWidth, canvasHeight) {
    if (!currentPreview) return;
    
    // Temporarily override canvas reference for coordinate calculations
    const tempCanvas = { width: canvasWidth, height: canvasHeight };
    const originalGetElementById = document.getElementById;
    document.getElementById = function(id) {
        if (id === 'previewCanvas') return tempCanvas;
        return originalGetElementById.call(document, id);
    };
    
    try {
        // Calculate reference coordinates
        const referenceCoords = calculateReferenceCoordinates();
        
        // Draw both sections using existing canvas drawing functions
        drawCompleteViewWithOverlay(ctx, referenceCoords);
        drawWallOnlyView(ctx, referenceCoords);
        
    } finally {
        // Restore original function
        document.getElementById = originalGetElementById;
    }
}

// Make generatePreview globally accessible
window.generatePreview = generatePreview;